export default __webpack_public_path__ + "static/media/groupIcon.f81eb95c.svg";